(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("axios"), require("react-dom"), require("react-router-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "axios", "react-dom", "react-router-dom"], factory);
	else if(typeof exports === 'object')
		exports["BCMS"] = factory(require("react"), require("axios"), require("react-dom"), require("react-router-dom"));
	else
		root["BCMS"] = factory(root["react"], root["axios"], root["react-dom"], root["react-router-dom"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_axios__, __WEBPACK_EXTERNAL_MODULE_react_dom__, __WEBPACK_EXTERNAL_MODULE_react_router_dom__) => {
return 